import { useTheme } from '@emotion/react';
import { SvgIcon } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';

export default function SendToIcon({ width = 50, height = 50, mb = 2 }) {
    const theme = useTheme();
    const primaryColor = theme.palette.text.primary;
    return (
        <SvgIcon sx={{ width, height, mb }}>
            <SendIcon />
        </SvgIcon>
    );
}
